<template>
  <div>
    <app-header><cp-nav></cp-nav></app-header>
    <section class="container">
      <div class="page-header">
        <h2>Formulário de Inscrição</h2>
      </div>

    </section>
  </div>
</template>

<script>
import AppHeader from '@/pages/layout/Header.vue'
import CpNav from './Nav.vue'

export default {
  name: 'CpInscricao',
  components: {
    AppHeader,
    CpNav
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// Inscricao.vue?748b42ea